var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 1.99999C5.71132 1.99999 4.66665 3.04466 4.66665 4.33332C4.66665 5.62199 5.71132 6.66666 6.99998 6.66666C8.28865 6.66666 9.33332 5.62199 9.33332 4.33332C9.33332 3.04466 8.28865 1.99999 6.99998 1.99999ZM3.33332 4.33332C3.33332 2.30828 4.97494 0.666656 6.99998 0.666656C9.02503 0.666656 10.6667 2.30828 10.6667 4.33332C10.6667 6.35837 9.02503 7.99999 6.99998 7.99999C4.97494 7.99999 3.33332 6.35837 3.33332 4.33332ZM6.99998 11C5.29864 11 3.68167 11.657 2.67254 12.1789C2.22498 12.4104 1.92259 12.8822 1.85421 13.4585L1.75042 14.3333H12.2495L12.1458 13.4585C12.0774 12.8822 11.775 12.4104 11.3274 12.1789C10.3183 11.657 8.70132 11 6.99998 11ZM2.05998 10.9946C3.1473 10.4322 4.98816 9.66666 6.99998 9.66666C9.01181 9.66666 10.8527 10.4322 11.94 10.9946C12.8459 11.4632 13.3586 12.3646 13.4698 13.3014L13.662 14.9214C13.6845 15.1106 13.6249 15.3003 13.4984 15.4428C13.3719 15.5852 13.1905 15.6667 13 15.6667H0.999983C0.809491 15.6667 0.628097 15.5852 0.501582 15.4428C0.375067 15.3003 0.315516 15.1106 0.33796 14.9214L0.530163 13.3015C0.641317 12.3646 1.15406 11.4632 2.05998 10.9946Z",
    fill: "#141F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMyAccount);
export default __webpack_public_path__ + "static/media/ProfileMyAccount.9645fcb2a69aeaeaa0d21982fd6232ce.svg";
export { ForwardRef as ReactComponent };